<script lang="ts">
	import { callCSButtonStyle } from '@lib/stores/main-layout.store';
	import { twMerge } from 'tailwind-merge';
	import WhatsApp from 'virtual:icons/ic/baseline-whatsapp';

	let className = '';

	export { className as class };
</script>

<a
	href="https://api.whatsapp.com/send?phone=6287834832315"
	target="_blank"
	rel="noopener noreferrer"
	style={$callCSButtonStyle}
	class={twMerge(
		'btn fixed bottom-5 right-5 z-50 rounded-full border-green-600 bg-green-100 px-5 text-green-600 shadow-soft duration-500 hover:border-green-600 hover:bg-green-200',
		className
	)}
>
	<WhatsApp class="text-xl" />
	Hubungi CS
</a>
